<div class="wrapper">
  <div class="container">
    <div class="inbound-integration">
      <div class="page-header">
        <h2 class="heading">インバウンド連携</h2>
      </div>
      <p class="caption">
        外部サービスと接続し、自動的にデータを取得・活用します。
      </p>
      @if (hasZoomIntegrationError) {
        <div class="alert">
          <mat-icon fontIcon="warning_amber" class="icon"></mat-icon>
          <div class="message">
            <span class="strong">zoom連携が切断されました。</span>
            <div>
              接続が切れた可能性があります。認証情報を確認し、再接続してください。
            </div>
          </div>
        </div>
      }
      <div class="zoom common-integration">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              <h2 class="card-heading">Zoomを連携</h2>
              <div class="card-caption">
                Zoomアカウントを連携することで、Zoomレコーディングを元にアセスメントを実施できるようになります。
              </div>
            </div>
            <mat-slide-toggle
              [(ngModel)]="isZoomIntegrationEnabled"
              (change)="onZoomToggleChange($event)"
            ></mat-slide-toggle>
          </div>
          @if (isZoomIntegrationEnabled) {
            <div class="card-actions">
              <button rectangle (click)="openZoomSettingDialog()">
                アセスメント設定
              </button>
            </div>
          }
        </div>
      </div>
      @if (hasAmptalkIntegrationError) {
        <div class="alert">
          <mat-icon fontIcon="warning_amber" class="icon"></mat-icon>
          <div class="message">
            <span class="strong">amptalk連携が切断されました。</span>
            <div>
              APIキーまたは認証キーの有効期限が切れた可能性があります。認証情報を確認し、更新を行ってください。
            </div>
          </div>
        </div>
      }
      <div class="amptalk common-integration">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              <h2 class="card-heading">amptalkを連携</h2>
              <div class="card-caption">
                amptalkアカウントを連携することで、コールデータを元にアセスメントを実施できるようになります。
              </div>
            </div>
            <mat-slide-toggle
              [(ngModel)]="isAmptalkIntegrationEnabled"
              (change)="onAmptalkToggleChange($event)"
            ></mat-slide-toggle>
          </div>
          @if (isAmptalkIntegrationEnabled) {
            <div class="card-actions">
              <button rectangle (click)="openAmptalkSettingDialog()">
                アセスメント設定
              </button>
              <button
                rectangle
                (click)="openAmptalkIntegrationDialog()"
                [disabled]="!isAmptalkIntegrationEnabled"
                variant="secondary"
              >
                <mat-icon>sync</mat-icon>
                認証キーを更新
              </button>
            </div>
          }
        </div>
      </div>
      @if (isBlueBeanFeatureEnabled) {
        <div class="bluebean common-integration">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2 class="card-heading">BlueBeanを連携</h2>
                <div class="card-caption">
                  BlueBeanアカウントを連携することで、通話データを元にアセスメントを実施できるようになります。
                </div>
              </div>
              <mat-slide-toggle
                [(ngModel)]="isBlueBeanIntegrationEnabled"
                (change)="onBlueBeanToggleChange($event)"
              ></mat-slide-toggle>
            </div>
            @if (isBlueBeanIntegrationEnabled) {
              <div class="card-actions">
                <button rectangle (click)="openBlueBeanOperatorMappingDialog()">
                  オペレーターマッピング
                </button>
                <button
                  rectangle
                  (click)="openBlueBeanIntegrationDialog()"
                  [disabled]="!isBlueBeanIntegrationEnabled"
                  variant="secondary"
                >
                  <mat-icon>sync</mat-icon>
                  連携設定を更新
                </button>
              </div>
            }
          </div>
        </div>
      }
      @if (canSeeKaikuraIntegration) {
        <div class="kaikura common-integration">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2 class="card-heading">カイクラを連携</h2>
                <div class="card-caption">
                  カイクラアカウントを連携することで、通話データを元にアセスメントを実施できるようになります。
                </div>
              </div>
              <mat-slide-toggle
                [(ngModel)]="isKaikuraIntegrationEnabled"
                (change)="onKaikuraToggleChange($event)"
              ></mat-slide-toggle>
            </div>
            @if (isKaikuraIntegrationEnabled) {
              <div class="card-actions">
                <button
                  rectangle
                  (click)="openKaikuraIntegrationDialog()"
                  [disabled]="!isKaikuraIntegrationEnabled"
                  variant="secondary"
                >
                  <mat-icon>sync</mat-icon>
                  連携設定を更新
                </button>
              </div>
            }
          </div>
        </div>
      }
      @if (isAmazonConnectFeatureEnabled) {
        <div
          class="amazon-connect common-integration"
          data-testid="amazon-connect-card"
        >
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2 class="card-heading">Amazon Connect を連携</h2>
                <div class="card-caption">
                  Amazon Connect の Contact Lens
                  分析データを自動で取り込み、アセスメントを実施できるようになります。
                </div>
              </div>
              <mat-slide-toggle
                aria-label="Amazon Connect 取り込み受付"
                [disabled]="
                  isAmazonConnectProcessing || !hasAmazonConnectSettingLoaded
                "
                [(ngModel)]="isAmazonConnectIntegrationEnabled"
                (change)="onAmazonConnectToggleChange($event)"
              ></mat-slide-toggle>
            </div>
            <div class="card-caption">
              @if (amazonConnectSetting?.lastReceivedAt; as receivedAt) {
                最終取り込み処理日時:
                {{
                  receivedAt | date: 'yyyy/MM/dd HH:mm'
                }}（取り込みのスキップも含む）
              } @else {
                未受信
              }
            </div>
            <div class="card-caption">
              取り込み受付を一時停止しても API キーは失効しません
            </div>
            @if (amazonConnectError) {
              <div class="alert" role="alert">
                <mat-icon fontIcon="warning_amber" class="icon"></mat-icon>
                <div class="message">{{ amazonConnectError }}</div>
              </div>
            }
            <div class="card-actions">
              @if (
                amazonConnectError !== null || !hasAmazonConnectSettingLoaded
              ) {
                <button
                  type="button"
                  rectangle
                  variant="secondary"
                  [disabled]="isAmazonConnectProcessing"
                  (click)="reloadAmazonConnectIntegrationSetting()"
                >
                  再読み込み
                </button>
              }
              <button
                rectangle
                [disabled]="isAmazonConnectProcessing"
                (click)="openInboundApiKeyManagementDialog()"
              >
                API キー管理
              </button>
              @if (amazonConnectSetting !== null) {
                <button
                  rectangle
                  variant="secondary"
                  [disabled]="
                    isAmazonConnectProcessing || !hasAmazonConnectSettingLoaded
                  "
                  (click)="openAmazonConnectIntegrationDialog()"
                >
                  <mat-icon>sync</mat-icon>連携設定を更新
                </button>
                <button
                  type="button"
                  rectangle
                  variant="secondary"
                  class="disconnect-button"
                  [disabled]="
                    isAmazonConnectProcessing ||
                    !hasAmazonConnectSettingLoaded ||
                    hasAmazonConnectDisconnected
                  "
                  (click)="openAmazonConnectDisconnectWarningDialog()"
                >
                  連携を解除
                </button>
              }
            </div>
          </div>
        </div>
      }
      @if (isBiztelFeatureEnabled) {
        <div class="biztel common-integration">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <h2 class="card-heading">BIZTELを連携</h2>
                <div class="card-caption">
                  BIZTELアカウントを連携することで、通話データを元にアセスメントを実施できるようになります。
                </div>
              </div>
              <mat-slide-toggle
                [(ngModel)]="isBiztelIntegrationEnabled"
                (change)="onBiztelToggleChange($event)"
              ></mat-slide-toggle>
            </div>
            @if (isBiztelIntegrationEnabled) {
              <div class="card-actions">
                <button rectangle (click)="openBiztelAccountMappingDialog()">
                  連携対象ユーザー設定
                </button>
                <button
                  rectangle
                  (click)="openBiztelPhoneNumberTagMappingDialog()"
                >
                  連携タグ設定
                </button>
                <button
                  rectangle
                  (click)="openBiztelIntegrationDialog()"
                  variant="secondary"
                >
                  <mat-icon>sync</mat-icon>
                  連携設定を更新
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <hr class="separator" />
    <div class="outbound-integration">
      <div class="page-header">
        <h2 class="heading">アウトバウンド連携</h2>
      </div>
      <p class="caption">
        AI Sales Coach内のデータを外部サービスに共有します。
      </p>
      @if (hasSalesforceIntegrationError) {
        <div class="alert">
          <mat-icon fontIcon="warning_amber" class="icon"></mat-icon>
          <div class="message">
            <span class="strong">Salesforce連携が切断されました。</span>
            <div>
              接続が切れた可能性があります。認証情報を確認し、再接続してください。
            </div>
          </div>
        </div>
      }
      <div class="salesforce common-integration">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              <h2 class="card-heading">Salesforceを連携</h2>
              <div class="card-caption">
                Salesforceアカウントを連携することでSalesforce商談にアセスメント結果やサマリ、進捗予測が表示されます。
              </div>
            </div>
            <mat-slide-toggle
              [(ngModel)]="isSalesforceIntegrationEnabled"
              (change)="onSalesforceToggleChange($event)"
            ></mat-slide-toggle>
          </div>
          @if (isSalesforceIntegrationEnabled) {
            <div class="card-actions">
              <button
                rectangle
                [disabled]="!isSalesforceIntegrationEnabled"
                (click)="validateSalesforceIntegrationSetting()"
              >
                設定検証
              </button>
              <button
                rectangle
                [disabled]="
                  !(
                    isSalesforceIntegrationEnabled &&
                    alreadyValidatedSalesforceIntegration
                  )
                "
                (click)="openOutboundSettingDialog()"
              >
                連携設定
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <app-loading [showLoading]="isLoading"></app-loading>
</div>
